export default function (ctx) {
    return {
      httpEndpoint: process.env.httpEndpoint,
      wsEndpoint: null,
      // getAuth: () => `Bearer ${token}`,
      defaultOptions: {
        $query: {
          loadingKey: 'loading',
          fetchPolicy: 'cache-and-network'
        }
      }
  }
}
